<div class="refund-dialog">

  <header class="refund-dialog__header">
    <div class="refund-dialog__title">
      <mat-icon>payments</mat-icon>
      <span>Refund Order</span>
    </div>
    <button class="refund-dialog__close" type="button" (click)="cancel()" aria-label="Close" matTooltip="Close">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <p class="refund-dialog__order-meta">
    <strong>{{ order?.title || order?.id }}</strong>
    <span class="refund-dialog__total">Order total: {{ formatDollars(order?.total) }}</span>
  </p>

  <div class="refund-dialog__mode-tabs" role="tablist" aria-label="Refund mode">
    <button class="refund-dialog__tab"
            type="button"
            role="tab"
            [class.is-active]="mode === 'full'"
            [attr.aria-selected]="mode === 'full'"
            (click)="setMode('full')">
      Full refund
    </button>
    <button class="refund-dialog__tab"
            type="button"
            role="tab"
            [class.is-active]="mode === 'partial'"
            [attr.aria-selected]="mode === 'partial'"
            (click)="setMode('partial')">
      Per-line refund
    </button>
  </div>

  <section *ngIf="mode === 'full'" class="refund-dialog__panel">
    <p class="refund-dialog__hint">
      Refunds the full order total back to the original payment method.
    </p>
    <div class="refund-dialog__total-line refund-dialog__total-line--lg">
      <span>Refund amount</span>
      <strong>{{ formatDollars(totalRefundCents()) }}</strong>
    </div>
  </section>

  <section *ngIf="mode === 'partial'" class="refund-dialog__panel">
    <p class="refund-dialog__hint">
      Pick the lines and the quantity / amount to refund. Refunded lines are excluded automatically.
    </p>

    <div class="refund-dialog__empty" *ngIf="lines.length === 0">
      No refundable lines remain on this order.
    </div>

    <ul class="refund-dialog__lines" *ngIf="lines.length > 0">
      <li class="refund-dialog__line"
          *ngFor="let line of lines"
          [class.is-selected]="line.selected">
        <label class="refund-dialog__line-check">
          <input type="checkbox" [checked]="line.selected" (change)="toggleLine(line)" aria-label="Select line for refund">
          <span class="refund-dialog__line-name">{{ line.name }}</span>
          <span class="refund-dialog__line-unit">{{ formatDollars(line.unitPrice) }} × {{ line.originalQty }}</span>
        </label>
        <div class="refund-dialog__line-inputs" *ngIf="line.selected">
          <label>
            <span>Qty</span>
            <input type="number" min="0" [max]="line.originalQty" [(ngModel)]="line.refundQty"
                   (ngModelChange)="onQtyChange(line)"
                   name="qty-{{line.lineItemId}}">
          </label>
          <label>
            <span>Amount</span>
            <input type="number" min="0" step="0.01"
                   [ngModel]="(line.refundAmount / 100).toFixed(2)"
                   (ngModelChange)="onAmountChange(line, $event)"
                   name="amt-{{line.lineItemId}}">
          </label>
        </div>
      </li>
    </ul>

    <div class="refund-dialog__total-line">
      <span>Selected refund total</span>
      <strong>{{ formatDollars(totalRefundCents()) }}</strong>
    </div>
  </section>

  <label class="refund-dialog__reason">
    <span>Reason (optional)</span>
    <input type="text" [(ngModel)]="reason" name="refundReason" maxlength="120" placeholder="e.g. customer dissatisfied">
  </label>

  <div class="refund-dialog__alert refund-dialog__alert--error" *ngIf="errorMessage">
    <mat-icon>error_outline</mat-icon>
    <span>{{ errorMessage }}</span>
  </div>
  <div class="refund-dialog__alert refund-dialog__alert--success" *ngIf="successMessage">
    <mat-icon>check_circle</mat-icon>
    <span>{{ successMessage }}</span>
  </div>

  <div class="refund-dialog__alert refund-dialog__alert--warn" *ngIf="confirmBeforeSubmit && !loading && !successMessage">
    <mat-icon>warning</mat-icon>
    <span>This will refund {{ formatDollars(totalRefundCents()) }} back to the original payment method (card or cash). This action cannot be undone. Click "Confirm Refund" to proceed.</span>
  </div>

  <footer class="refund-dialog__footer">
    <button class="refund-dialog__btn refund-dialog__btn--ghost" type="button" (click)="cancel()" [disabled]="loading">
      Cancel
    </button>
    <button class="refund-dialog__btn refund-dialog__btn--primary"
            type="button"
            (click)="submit()"
            [disabled]="!canSubmit()"
            [class.refund-dialog__btn--confirm]="confirmBeforeSubmit">
      <mat-spinner *ngIf="loading" diameter="18"></mat-spinner>
      <span *ngIf="!loading && !confirmBeforeSubmit">Refund {{ formatDollars(totalRefundCents()) }}</span>
      <span *ngIf="!loading && confirmBeforeSubmit">Confirm Refund {{ formatDollars(totalRefundCents()) }}</span>
      <span *ngIf="loading">Processing…</span>
    </button>
  </footer>
</div>
